import Button from '@rategravity/frontend/components/button';
import { event } from '@rategravity/frontend/modules/user-actions';
import { stringify } from 'querystring';
import React from 'react';
import { redactPiiFields } from '../../modules/pii-filter';
import './style.styl';

const YouCanBookMeButton = ({
  purpose,
  advisor,
  prefill,
  onClick = () => false,
  children,
  actionPipe,
  ...props
}) => {
  const baseUrl = `https://consult.ownup.com/schedule/${purpose}${advisor ? `/${advisor}` : ''}?`;
  const to = `${baseUrl}${stringify(prefill)}`;
  const toPiiStripped = `${baseUrl}${stringify(redactPiiFields(prefill))}`;
  return (
    <a href={to}>
      <Button
        onClick={(e) => {
          e.preventDefault();
          actionPipe.next(event('Clicked Schedule Time', { consultUrl: toPiiStripped }));
          // wait 10ms for stuff to propogate
          window.setTimeout(() => {
            window.open(to, '_top');
          }, 10);
          return onClick(e);
        }}
        className="ycbm-btn"
        {...props}
      >
        {children}
      </Button>
    </a>
  );
};

export default YouCanBookMeButton;



// WEBPACK FOOTER //
// ./src/components/you-can-book-me/index.js